import React from 'react';
import { ClaimManagementModalProps } from '@/interface';
import { ClaimTokenModal } from '@/lib';

const ClaimManagementModal = ({
  open,
  skipClaimModal,
  firstName,
  lastName,
  userEmail,
  config,
  claimItemId,
  claimCode,
  link,
  content,
  tokenGatingConfig,
  tokenName,
  saleType,
  isClaimWithGas,
  onCloseModal,
  onSuccess
}: ClaimManagementModalProps) => {
  return (
    <ClaimTokenModal
      open={open}
      skipClaimModal={skipClaimModal}
      onCloseModal={onCloseModal}
      claimType={saleType}
      firstName={firstName}
      lastName={lastName}
      userEmail={userEmail}
      config={config}
      listingId={claimItemId}
      claimCode={claimCode}
      link={link}
      content={content}
      tokenGatingConfig={tokenGatingConfig}
      tokenName={tokenName}
      showBuyButton={false}
      isClaimWithGas={isClaimWithGas}
      skipAPI={true}
      onSuccess={onSuccess}
    />
  );
};

export default ClaimManagementModal;
